type RequestSelectionBoxesStatusType = 'AVAILABLE' | 'DONE' | 'TODO';

enum RequestSelectionBoxesStatus {
  AVAILABLE = 'AVAILABLE',
  DONE = 'DONE',
  TODO = 'TODO',
}

enum RequestSelectionBoxesStep {
  RETAILER = 'retailer',
  SLOT = 'slot',
  PERSONAL_DATA = 'personalData',
  NONE = 'none',
}

enum RequestSelectionBoxesStepNumbers {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export {
  RequestSelectionBoxesStatusType,
  RequestSelectionBoxesStatus,
  RequestSelectionBoxesStep,
  RequestSelectionBoxesStepNumbers,
};
